"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitResizer = exports.Pane = exports.SplitPane = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSplitPane = styled_components_1.default.div `
  display: flex;
  overflow: hidden;
  flex: 1;
  &.vertical {
    flex-direction: column;
  }
  .split-pane:last-child {
    /* flex: 1 1 auto; */
  }
`;
const SplitPane = (_a) => {
    var { ref, primary = 'previous', direction = 'horizontal', children, className = '', width, height } = _a, props = __rest(_a, ["ref", "primary", "direction", "children", "className", "width", "height"]);
    const [dragState, setDragState] = (0, react_1.useState)();
    const isPrevious = primary === 'previous';
    const handleStartDrag = (0, react_1.useCallback)((element, x, y) => {
        if (element.parentElement) {
            // disable pointer events on panes being resized (prevents iframes taking
            // over mouse events)
            toggleChildPointerEvents(element.parentElement);
        }
        setDragState({
            position: direction === 'horizontal' ? x : y,
            element: (isPrevious
                ? element.previousSibling
                : element.nextSibling)
        });
    }, [direction, isPrevious]);
    const handleDrag = (0, react_1.useCallback)((x, y) => {
        if (!(dragState === null || dragState === void 0 ? void 0 : dragState.element)) {
            return;
        }
        const multiplier = isPrevious ? 1 : -1;
        const position = direction === 'horizontal' ? x : y;
        const styleSize = direction === 'horizontal' ? 'width' : 'height';
        const rect = dragState.element.getBoundingClientRect();
        const diff = (position - dragState.position) * multiplier;
        const size = rect[styleSize] + diff;
        dragState.element.style[styleSize] = `${size}px`;
        dragState.element.style.flex = '0 0 auto';
        setDragState({ element: dragState.element, position });
    }, [direction, dragState, isPrevious]);
    const pauseEvent = (event) => {
        var _a, _b;
        // prevent text selection while dragging
        (_a = event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        (_b = event.preventDefault) === null || _b === void 0 ? void 0 : _b.call(event);
        event.cancelBubble = true;
        event.returnValue = false;
    };
    const handleMouseMove = (0, react_1.useCallback)((event) => {
        if (!dragState)
            return; // allow mouse move to propagate
        pauseEvent(event);
        handleDrag(event.clientX, event.clientY);
    }, [handleDrag]);
    const handleTouchMove = (0, react_1.useCallback)((event) => {
        if (!dragState)
            return; // allow mouse move to propagate
        pauseEvent(event);
        handleDrag(event.touches[0].clientX, event.touches[0].clientY);
    }, [handleDrag]);
    const handleMouseUp = (0, react_1.useCallback)(() => {
        var _a;
        if ((_a = dragState === null || dragState === void 0 ? void 0 : dragState.element) === null || _a === void 0 ? void 0 : _a.parentElement) {
            toggleChildPointerEvents(dragState.element.parentElement);
        }
        setDragState(undefined);
    }, [dragState]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('mouseup', handleMouseUp);
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('touchmove', handleTouchMove);
        return () => {
            window.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('touchmove', handleTouchMove);
        };
    }, [handleMouseMove, handleMouseUp, handleTouchMove]);
    // remove null children
    const childComponents = react_1.default.Children.toArray(children).filter(c => c);
    const classes = ['split-pane'];
    if (direction)
        classes.push(direction);
    if (className)
        classes.push(className);
    return (react_1.default.createElement(StyledSplitPane, Object.assign({ ref: ref, className: classes.join(' ') }, props, { style: width !== undefined
            ? {
                flex: `0 0 auto`,
                width: `${width}${typeof width === 'number' ? 'px' : ''}`
            }
            : height !== undefined
                ? {
                    flex: '0 0 auto',
                    height: `${height}${typeof height === 'number' ? 'px' : ''}`
                }
                : {} }), childComponents.map((child, index) => (react_1.default.createElement(react_1.Fragment, { key: index },
        child,
        index < childComponents.length - 1 && (react_1.default.createElement(exports.SplitResizer, { direction: direction, onMouseDown: event => {
                handleStartDrag(event.target, event.clientX, event.clientY);
            }, onTouchStart: event => {
                handleStartDrag(event.target, event.touches[0].clientX, event.touches[0].clientY);
            } })))))));
};
exports.SplitPane = SplitPane;
const StyledPane = styled_components_1.default.div `
  flex: 1;
  &.flex {
  }
`;
const Pane = (_a) => {
    var { children, flex, width, height, innerRef, className = '' } = _a, props = __rest(_a, ["children", "flex", "width", "height", "innerRef", "className"]);
    return (react_1.default.createElement(StyledPane, Object.assign({ ref: innerRef, style: { width, height }, className: `${flex && 'flex'} ${className}` }, props), children));
};
exports.Pane = Pane;
const borderStyle = '5px solid rgba(255, 255, 255, 0)';
const borderHoverStyle = '5px solid rgba(255, 255, 255, 0.15)';
const StyledSplitResizer = styled_components_1.default.div `
  position: relative;
  background: #555;
  box-sizing: border-box;
  background-clip: padding-box !important;
  transition: border 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);

  &.horizontal {
    width: 11px;
    margin: 0 -5px;
    cursor: col-resize;
    border-left: ${borderStyle};
    border-right: ${borderStyle};
    &:hover {
      border-left: ${borderHoverStyle};
      border-right: ${borderHoverStyle};
    }
  }

  &.vertical {
    height: 11px;
    margin: -5px 0;
    cursor: row-resize;
    border-top: ${borderStyle};
    border-bottom: ${borderStyle};
    &:hover {
      border-top: ${borderHoverStyle};
      border-bottom: ${borderHoverStyle};
    }
  }
`;
const SplitResizer = ({ direction, onMouseDown, onTouchStart }) => {
    return (react_1.default.createElement(StyledSplitResizer, { className: `resizer ${direction}`, onMouseDown: onMouseDown, onTouchStart: onTouchStart }));
};
exports.SplitResizer = SplitResizer;
exports.default = exports.SplitPane;
// Helper functions
function toggleChildPointerEvents(element) {
    Array.from(element.children).forEach(e => {
        const element = e;
        if (!element.className.includes('resizer')) {
            if (element.style.pointerEvents === 'none') {
                element.style.pointerEvents = 'auto';
            }
            else {
                element.style.pointerEvents = 'none';
            }
        }
    });
}
//# sourceMappingURL=SplitPane.js.map